// extracted by mini-css-extract-plugin
export default {"container":"Pagination_container__g6eEy","icon":"Pagination_icon__irY4i"};